import { useCmsCopyStore } from "@akina/presentation";

const CMS_BASE_KEY = "webshop/checkout-page/SelectTherapyPlanStep/PatientFacingTherapyPlans";

export type CmsTherapyPlan = {
  original_therapy_plan_key: string;
  checkout_body_part_key: string;
  DisplayedBodyPart: string;
  DisplayedName: string;
  Description: string;
};

export function findPlanDisplayedName(plans: CmsTherapyPlan[], templateKey: string | null): string {
  return plans.find(p => p.original_therapy_plan_key === templateKey)?.DisplayedName ?? "";
}

export const useCmsTherapyPlans = () => {
  const localeCopy = useCmsCopyStore(s => s.cmsCopy?.localeCopy);
  const isLoading = useCmsCopyStore(s => s.isLoadingCmsCopy);

  const indexPattern = new RegExp(String.raw`^${CMS_BASE_KEY}/(\d+)/original_therapy_plan_key$`);
  const indices = Object.keys(localeCopy ?? {})
    .map(key => indexPattern.exec(key)?.[1])
    .filter((v): v is string => v !== undefined)
    .map(Number)
    .sort((a, b) => a - b);

  const plans: CmsTherapyPlan[] = indices.map(i => ({
    original_therapy_plan_key: localeCopy?.[`${CMS_BASE_KEY}/${i}/original_therapy_plan_key`] ?? "",
    checkout_body_part_key: localeCopy?.[`${CMS_BASE_KEY}/${i}/checkout_body_part_key`] ?? "",
    DisplayedBodyPart: localeCopy?.[`${CMS_BASE_KEY}/${i}/DisplayedBodyPart`] ?? "",
    DisplayedName: localeCopy?.[`${CMS_BASE_KEY}/${i}/DisplayedName`] ?? "",
    Description: localeCopy?.[`${CMS_BASE_KEY}/${i}/Description`] ?? "",
  }));

  const universalPlan = plans.find(p => p.checkout_body_part_key === "all");

  const bodyPartMap: Record<string, string> = {};
  for (const plan of plans) {
    const key = plan.checkout_body_part_key;
    if (key && key !== "all" && !(key in bodyPartMap)) {
      bodyPartMap[key] = plan.DisplayedBodyPart;
    }
  }

  const bodyParts = Object.keys(bodyPartMap).sort((a, b) => {
    if (a === "other") return 1;
    if (b === "other") return -1;
    return 0;
  });

  return { plans, universalPlan, bodyParts, bodyPartMap, isLoading };
};
